export * from './api.interface';
export * from './generic-api';
export * from './server-data.model';
export * from './page.model';
export * from './page-options.model';



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/ng-api/index.ts